import {Page, Button, Card, Text} from "@shopify/polaris";
import React from "react";
import {Redirect} from "@shopify/app-bridge/actions";
import Http from "../../Lib/Http";
import Stepper from "./Stepper"

function StartOnboarding() {

    const next = () => {
        let redirect = Redirect.create(window.app);
        redirect.dispatch(Redirect.Action.APP, '/app/wizard/2');
    }

    return (
        <Page>
            <div>
                <Stepper currentStep={0}/>
                <Card>
                    <div className="Turbo-Dasboard--Empty-State-Container">
                        <div className="Turbo-Dasboard--Empty-State-Section">
                        </div>
                        <div className="Turbo-Dasboard--Empty-State-Section ">
                             <Text variant="headingXl" as="h4">
                                Welcome to Size Matters
                            </Text>
                            <Text variant="headingMd" as="h6">
                                Hassle-free Size Charts
                            </Text>
                            <div className="Turbo-Dasboard--Empty-State-Subtilte-Container">
                                <div className="nbis-pt-10">
                                    <ul className="nbis-list-ticked">
                                        <li> A 12% average increase in sales</li>
                                        <li> Increased customer loyalty</li>
                                        <li> Reduced return rates</li>
                                    </ul>
                                </div>
                                <p>
                                    Save time by quickly and easily creating as many size giudes as you like. Fully
                                    customise size guides with seamlessly matching the look and feel of your store and
                                    making it very simple for your customer to find their required size.
                                </p>
                                <p>
                                    <br/>
                                    Reduce return rates with size charts and size guides for FREE.
                                </p>
                            </div>
                            <Button  onClick={next} size="large" fullWidth>Get Started</Button>
                        </div>
                    </div>
                </Card>


            </div>
        </Page>
    );
}

export default StartOnboarding;
